import { Card, Col, Row, Form } from "react-bootstrap";
import { IFindingAndRecommendationDetails } from "../../../api/IFindingAndRecommendation";
import EpaField2Rows from "../../../leap-components/EpaField2Rows";
import { LicenseeReturnIcon } from "../../../leap-components/icons/LeapIcons";

interface FindingAndRecommendationHeaderProps {
  findingAndRecommendation: IFindingAndRecommendationDetails;
}

const FindingAndRecommendationHeader = ({
  findingAndRecommendation,
}: FindingAndRecommendationHeaderProps) => {
  return (
    <Card className="flex-fill w-100">
      <Card.Header></Card.Header>
      <Card.Body className="pt-0">
        <Row>
          <Col className="col-12 col-md-6">
            <table className="no-border" style={{ marginTop: "0.6rem" }}>
              <tbody>
                <tr>
                  <td>
                    <LicenseeReturnIcon />
                  </td>
                  <td>
                    <h2>
                      {`Finding / Recommendation: ${findingAndRecommendation.reference}`}
                    </h2>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="d-md-none" style={{ height: "20px" }}></div>
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Reference No."}
              value={findingAndRecommendation.reference}
            />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Status"}
              value={findingAndRecommendation.status}
            />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Authorisation Version"}
              value={findingAndRecommendation.licence_regno}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default FindingAndRecommendationHeader;
